
import { ContactMasterData} from "types/models/contactMaster/ContactMasterApp";
import { AppActions } from "../../types";
import { GET_CONTACT, RESET_CONTACT_DATA, SET_CONTACT_DATA } from "types/actions/contactMaster.action";
export enum VIEW_TYPE {
  LIST = 1,
  GRID = 2,
}

const initialState: {
  currentContact: ContactMasterData | null;
  contact: ContactMasterData[];
  contactCount: number;
 
} = {
  currentContact: null,
  contact: [],
  contactCount: 0,
  
};

const ContactMaster = (state = initialState, action: AppActions) => {
  switch (action.type) {
    // Plan-related actions
    case GET_CONTACT:
      return {
        ...state,
        contact: action.payload.data,
        contactCount: action.payload.total,
      };
    case SET_CONTACT_DATA:
      return {
        ...state,
        currentContact: action.payload,
      };
      case RESET_CONTACT_DATA:
        return { ...state, currentContact: null };
    default:
      return state; 
  }
};

export default ContactMaster;
